export default {
    props: {
        editableMode: {
            type: String,
            default: undefined,
            kComposite: 'editable.mode'
        }, 
        editableMove: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.move'
        }, 
        editableTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'editable.template'
        }, 
        editableWindow: {
            type: Object,
            default: undefined,
            kComposite: 'editable.window'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeList/Editable.js